const versionUtils = {
	/**
	 * Retrieve the active system version from config
	 * @returns {String}
	 */
	getSystemVersion() {
		const systemVersion = this.$config.version;
		if (!semver.valid(systemVersion)) console.warn(`Current system version is not semver-valid: ${systemVersion}`);
		return this.$config.version || '0.0.0';
	},


	/**
	 * Retrieve the versions supported by active system
	 * @returns {String}
	 */
	getSystemSupported() {
		return _.get(this.$config, 'peers.active.supportsOrderVersion', this.getSystemVersion());
	},


	/**
	 * Determine if entity version is exact match to system's version
	 * @param {Object} entity Versioned entity
	 * @returns {Boolean}
	 */
	checkVersionMatch(entity) {
		if (!entity) return false;

		const systemVersion = this.getSystemVersion();
		const entityVersion = this.getEntityVersion(entity);

		return (semver.eq(entityVersion, systemVersion));
	},


	/**
	 * Determine if entity version is supported by current system
	 * @param {Object} entity Versioned entity
	 * @returns {Boolean}
	 */
	checkVersionSupported(entity) {
		if (!entity) return false;

		const supportedVersions = this.getSystemSupported();
		const entityVersion = this.getEntityVersion(entity);

		return (semver.validRange(supportedVersions) && semver.satisfies(entityVersion, supportedVersions));
	},


	/**
	 * Retrieve version from entity
	 * @param {String} entity Object with `verion` field that is the string representing the version
	 * @returns {String}
	 */
	getEntityVersion(entity) {
		return semver.valid(entity?.version) ? entity.version : '0.0.0';
	},


	/**
	 * Retrieve list of supported peers given a version number
	 * 
	 * @param {String} version Semver
	 * @returns {Array}
	 */
	getSupportedPeers(version) {
		return Object.entries(this.$config?.peers)
			.filter((peer) => peer[0] !== 'active' // Exclude current system
				&& peer[0] !== this.$config.env
			)
			.map((peer) => peer[1])
			.filter((peer) => !_.isString(peer.showOrderVersionLink) || eval(peer.showOrderVersionLink))
			.filter(
				(peer) =>
					semver.validRange(peer.supportsOrderVersion)
					&& semver.satisfies(version, peer.supportsOrderVersion),
			);
	},
}

module.exports = versionUtils;
